<template>
  <div id="app">
    <main v-if="!loading" class="flex-1">
      <transition mode="out-in">
        <router-view />
      </transition>
    </main>
    <PageLoading v-else />
  </div>
</template>

<script>
import { api } from "@/services";

export default {
  data() {
    return {
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    if (window.localStorage.CHIAuPairAuthToken) {
      try {
        await api.validate();
        await this.$store.dispatch("getUser");
        this.loading = false;
      } catch (error) {
        this.$router.push({ name: "Login" });
        window.localStorage.removeItem("CHIAuPairAuthToken");
        this.loading = false;
      }
    } else {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss">
@import "~pretty-checkbox/src/pretty-checkbox.scss";

.pretty input:checked ~ .state.p-success label:after,
.pretty.p-toggle .state.p-success label:after {
  background-color: #9a69cb !important;
}

.pretty.p-switch.p-fill input:checked ~ .state.p-success:before {
  background-color: #9a69cb !important;
}
.pretty.p-switch input:checked ~ .state.p-success:before {
  border-color: #9a69cb;
}

.multiselect__tag {
  background: #9a69cb !important;
}

.multiselect__tag-icon:after {
  content: "\D7";
  color: #fff !important;
  font-size: 14px;
}

body {
  margin: 0;
  background: #f4f4f4;
  font-size: 18px;
}

.btn {
  @apply font-bold;
  padding: 10px 20px;
  @apply rounded;
  transition: all 0.3s;
  cursor: pointer;
  outline: none;

  &:disabled {
    color: #fff;
    background: rgba(0, 0, 0, 0.25);

    &:hover {
      transform: none;
    }
  }

  &:hover {
    @apply shadow-md;
    transform: scale(1.08);
    transition: all 0.3s;
  }
}

.btn-purple:hover,
.btn-purple:active,
.btn-purple {
  @apply bg-purple-ap-100;
  @apply text-white;
}

.btn-white:hover,
.btn-white:active,
.btn-white {
  @apply bg-white;
  @apply text-purple-ap-100;
}

/* transitions*/
.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

/* toasts */
.notificate {
  padding: 10px 30px !important;
  box-shadow: none !important;
}

.notificate.error {
  background-color: rgb(211, 42, 42) !important;
}

.notificate.info {
  background-color: rgb(85, 147, 241) !important;
}

.notificate.success {
  background-color: rgb(79, 150, 82) !important;
}

.notificate a {
  color: #fff !important;
}

form .errors {
  color: #dc3545;
  @apply text-xs;
}

.chi-form input[disabled] {
  background: #e4e4e4;
}

.chi-form h2 {
  @apply mb-3;
  font-weight: 600;
  @apply text-purple-ap-100;
}

.vdp-datepicker input {
  border: 1px solid rgba(0, 0, 0, 0.25) !important;
  font-size: 1rem;
  @apply appearance-none;
  @apply block;
  @apply w-full;
  @apply rounded;
  @apply py-3;
  @apply px-4;
  @apply mb-1;
}

.vdp-datepicker input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.vdp-datepicker input.is-dity,
.vdp-datepicker input.is-invalid {
  border: 1px solid #dc3545 !important;
}
.vdp-datepicker input.is-dity,
.vdp-datepicker input.is-valid {
  border: 1px solid #28a745 !important;
}
.vdp-datepicker input.is-dity:focus,
.vdp-datepicker input.is-invalid:focus {
  border: 1px solid #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(240, 0, 0, 0.25) !important;
}
.vdp-datepicker input.is-dirty:focus,
.vdp-datepicker input.is-valid:focus {
  border: 1px solid #28a745 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.4) !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.apply {
  width: 100%;
  padding: 15px 0;
  border-radius: 4px;
  margin: 0;
  font-weight: 600;
}

.apply:disabled {
  color: #efefef;
  background: rgba(0, 0, 0, 0.3);
}

.apply:hover {
  transform: scale(1.02);
}

.apply:disabled:hover {
  transform: none;
}

/* animations */
.animeLeft {
  opacity: 0;
  transform: translateX(-20px);
  animation: animeLeft 0.3s forwards;
}

@keyframes animeLeft {
  to {
    opacity: initial;
    transform: initial;
  }
}
</style>
